var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleArrowClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500001 0.718826C0.500001 0.273374 1.03857 0.0502901 1.35355 0.365273L7.14645 6.15817C7.34171 6.35343 7.34171 6.67001 7.14645 6.86527L1.35355 12.6582C1.03857 12.9731 0.500002 12.7501 0.500002 12.3046L0.500002 6.51172L0.500001 0.718826Z",
    fill: "#899AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrowClosed);
export default __webpack_public_path__ + "static/media/triangle_arrow_closed.c20a06538d821f720b4e603cd996774a.svg";
export { ForwardRef as ReactComponent };